import { HeadersFunction, LoaderFunction, LoaderFunctionArgs, MetaFunction } from "react-router";
import SaangDhyan from "~/components/AppsInfo/SaangDhyan";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { CACHED_PAGE, FALLBACK_IMAGE_URL, LANG } from "~/utils/constant";
import { computeEtagFromData } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const loader: LoaderFunction = ({ params, request }: LoaderFunctionArgs) => {
  const lang = params.lang || LANG.english;

  const DATA = { title: lang === LANG.english ? "Saang Dhyan - 3D Darshan" : "સાંગ ધ્યાન - 3D દર્શન" };
  const etag = computeEtagFromData(DATA);

  const ifNoneMatch = request.headers.get("If-None-Match");

  if (ifNoneMatch === etag) {
    return new Response(null, {
      status: 304,
      headers: {
        ETag: etag,
      },
    });
  }
  return Response.json(DATA, {
    headers: { ...CACHED_PAGE.APPS.HEADERS, ETag: etag },
  });
};

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

export const meta: MetaFunction = ({ location, params }) => {
  const { pathname, search } = location;
  const lang = params.lang || "en";
  const meta = getPageMeta("apps", lang);
  const title = lang === "gu" ? "સાંગ ધ્યાન - 3D દર્શન" : "Saang Dhyan - 3D Darshan";
  return metaService({
    title: title ?? meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: title ?? meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    ogUrl: pathname,
    canonicalLink: pathname + search,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

const SaangDhyanPage = () => {
  return (
    <div className="w-full flex justify-center items-center">
      <SaangDhyan />
    </div>
  );
};

export default SaangDhyanPage;
